export const PP_TYPE = "pp"
export const BP_TYPE = "bp"
export const PP_MULTI_TYPE = "pp_multi"
